import { apiClient } from './apiClient';
import type {
  PaginatedDuplicateResponse,
  MergeContactsRequest,
  MergeContactsResponse,
  UnifiedContact,
} from '../../types/contact';

export const adminContactService = {
  /**
   * Get list of duplicate contact groups
   */
  getDuplicates: async (): Promise<PaginatedDuplicateResponse> => {
    const response = await apiClient.get<PaginatedDuplicateResponse>(
      '/admin/contacts/duplicates/'
    );
    return response.data;
  },

  /**
   * Merge duplicate contacts into a primary contact
   */
  mergeContacts: async (data: MergeContactsRequest): Promise<MergeContactsResponse> => {
    const response = await apiClient.post<MergeContactsResponse>(
      '/admin/contacts/merge/',
      data
    );
    return response.data;
  },

  /**
   * Update contact personal data (admin only)
   */
  updateContact: async (id: string, data: Partial<UnifiedContact>): Promise<UnifiedContact> => {
    const response = await apiClient.patch<UnifiedContact>(
      `/admin/contacts/${id}/`,
      data
    );
    return response.data;
  },
};
